import React from 'react';
import classNames from 'classnames';
import {SectionProps} from '../../utils/SectionProps';
import Image from '../elements/Image';
import ContentPrivacy from "./partials/ContentPrivacy";
import Cta_About from "./Cta_about";
import {FormattedMessage} from "react-intl";

const propTypes = {
    ...SectionProps.types
}

const defaultProps = {
    ...SectionProps.defaults
}

const Hero_Privacy = ({
                          className,
                          topOuterDivider,
                          bottomOuterDivider,
                          topDivider,
                          bottomDivider,
                          hasBgColor,
                          invertColor,
                          ...props
                      }) => {

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    return (
        <section{...props} className={outerClasses}>
            <div className="container-sm">
                <div className={innerClasses}>
                    <div className="hero-content">
                        <h1 className="mt-0 reveal-from-bottom" data-reveal-delay="200">
                            <span className="text-color-primary">
                                <FormattedMessage
                                    id="app.hero.privacy_title"
                                    defaultMessage="Política de privacidad"
                                />
                            </span>
                        </h1>
                        <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px"
                             data-reveal-delay="800">
                            <Image
                                src={require('./../../assets/images/hero_privacy.png')}
                                alt="Hero"
                                width={450}
                                height={32}/>
                        </div>
                        <ContentPrivacy/>
                        <Cta_About split/>
                    </div>
                </div>
            </div>
        </section>
    );
}

Hero_Privacy.propTypes = propTypes;
Hero_Privacy.defaultProps = defaultProps;

export default Hero_Privacy;